"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValuationStepDefinition = void 0;
const WidgetStepPluginDefinition_1 = require("auto-widget-framework/src/Plugin/WidgetStep/WidgetStepPluginDefinition");
const TemplateTypes_1 = require("../../../../Enum/TemplateTypes");
const StepTypes_1 = require("../../../../Enum/StepTypes");
const InchcapeBaseEvents_1 = require("../../../../Enum/InchcapeBaseEvents");
const InchcapeSelectorEvents_1 = require("../../Enum/InchcapeSelectorEvents");
const WidgetStepPlugin_1 = require("auto-widget-framework/src/Plugin/WidgetStep/WidgetStepPlugin");
const StepEvents_1 = require("auto-widget-framework/src/Widget/EventDefinition/StepEvents");
const QuestionnaireTypes_1 = require("../../../../Enum/QuestionnaireTypes");
const QuestionAnswerOptionType_1 = require("../../../../Enum/QuestionAnswerOptionType");
const configs_1 = require("../../../../configs/configs");
const PriceMetaTypes_1 = require("../../../../Enum/PriceMetaTypes");
const chroma = require("chroma-js");
//Step #6
class ValuationStep extends WidgetStepPlugin_1.default {
    constructor(definition, widgetConfig, state, eventContext, ractiveWrapper, priceExtractor, answerExtractor) {
        super(definition, widgetConfig, state, eventContext, ractiveWrapper);
        this.priceExtractor = priceExtractor;
        this.answerExtractor = answerExtractor;
    }
    /**
     * @inheritDoc
     * @see IContainerInjection
     */
    static create(definition, widgetConfig, state, eventContext, container) {
        return new this(definition, widgetConfig, state, eventContext, container.get("ractive_wrapper"), container.get("valuation.price_extractor"), container.get("valuation.answer_extractor"));
    }
    /**
     * @inheritDoc
     */
    getTemplate() {
        return this.widgetConfig.getTemplate(TemplateTypes_1.TemplateTypes.VALUATION).getTemplate();
    }
    /**
     * @inheritDoc
     */
    initialize() {
        const currentValuation = this.state.getValuation();
        this.state.setNextStepAnswersEnum(QuestionAnswerOptionType_1.QuestionNextStepsAnswers);
        this.state.setValuationPrice(this.priceExtractor.getActualPrice(currentValuation));
        if (currentValuation.getValuationData().hasPriceRanges()) {
            this.initializeRangedValuationState(currentValuation);
        }
        if (!this.state.getUserNextStepChoice()) {
            const finalAnswer = this.answerExtractor.getAnswerToQuestion(currentValuation, QuestionnaireTypes_1.QuestionnaireTypes.NEXT_ACTIONS, QuestionnaireTypes_1.QuestionnaireTypes.NEXT_ACTIONS);
            this.state.setUserNextStepChoice(finalAnswer === QuestionAnswerOptionType_1.QuestionNextStepsAnswers.SELL
                ? QuestionAnswerOptionType_1.QuestionNextStepsAnswers.SELL
                : QuestionAnswerOptionType_1.QuestionNextStepsAnswers.TRADE_IN);
        }
        return Promise.resolve();
    }
    initializeRangedValuationState(valuation) {
        let minPrice = this.priceExtractor.getActualPrice(valuation, PriceMetaTypes_1.PriceMetaTypes.MIN);
        let maxPrice = this.priceExtractor.getActualPrice(valuation, PriceMetaTypes_1.PriceMetaTypes.MAX);
        let price = this.priceExtractor.getActualPrice(valuation);
        let pricePercentage = Math.max(Math.min((price - minPrice) / (maxPrice - minPrice), 1), 0);
        this.state.setRangedValuationPrice();
        this.state.setPriceColor(chroma.scale(['#f46113', '#fbdc00', '#5bac3b'])(pricePercentage).toString());
        this.state.setValuationMinPrice(minPrice);
        this.state.setValuationMaxPrice(maxPrice);
    }
    render() {
        const result = super.render();
        this.renderer.set("submit", this.submit.bind(this));
        this.renderer.set("onImageError", this.onImageError.bind(this));
        return result;
    }
    /**
     * @inheritDoc
     */
    submit() {
        const valuation = this.state.getValuation();
        this.eventContext.emit(StepEvents_1.StepEvents.STEP_FINISHED);
        this.eventContext.emit(InchcapeBaseEvents_1.InchcapeBaseEvents.CLOSE, valuation);
        this.eventContext.emit(InchcapeSelectorEvents_1.InchcapeSelectorEvents.CLOSE_FINISHED);
    }
    onImageError(event) {
        const carImage = event === null || event === void 0 ? void 0 : event.node;
        if (carImage) {
            carImage.src = configs_1.configs.externalAssets.imageNotFound;
            carImage.onerror = null;
        }
    }
}
exports.default = ValuationStep;
exports.ValuationStepDefinition = new WidgetStepPluginDefinition_1.default({
    id: StepTypes_1.StepTypes.VALUATION,
    class: ValuationStep,
    priority: 1000
});
